import { UtilityAccountSelectionScreenMap } from '~/machines/utility-account-selection/screen-map';
import { ScreenMapCopy } from '~/machines/utils/types';

export const copy: ScreenMapCopy<UtilityAccountSelectionScreenMap> = {};
